<ng-container [ngSwitch]="model">
  <ng-container *ngSwitchCase="ProficiencyEnum.NOTIONS" i18n>Notions</ng-container>
  <ng-container *ngSwitchCase="ProficiencyEnum.INTERMEDIATE" i18n>Intermédiaire</ng-container>
  <ng-container *ngSwitchCase="ProficiencyEnum.PROFESSIONAL" i18n>Professionnel</ng-container>
  <ng-container *ngSwitchCase="ProficiencyEnum.NATIVE_LANGUAGE" i18n>Langue maternelle</ng-container>
</ng-container>
